// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { HeaderSearchQuery } from "@guestsupply/App/Handlers/XNG/SearchQueryHandler";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";

import { Draft } from "immer";

export type SearchQueryState = Readonly<{
    query: string;
}>;

const initialState: SearchQueryState = {
    query: "",
};
const reducer = {
    "xSearchQuery/SetQuery": (draft: Draft<SearchQueryState>, action: { data: HeaderSearchQuery }) => {
        draft.query = action.data.query;
    },
};

const xSearchQuery = createTypedReducerWithImmer(initialState, reducer);

(reducers as any).xSearchQuery = xSearchQuery;

export type xSearchQueryState = {
    xSearchQuery: SearchQueryState;
} & ApplicationState;

type SearchQueryReducers = {
    query: typeof xSearchQuery;
};

export type xSearchQuery = Parameters<SearchQueryReducers[keyof SearchQueryReducers]>[1] | AnyAction;
